import Base from './Base'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()
		console.log('legales')

		//LEGALES
		gsap.registerPlugin(ScrollTrigger);

		gsap.to(".sticky-content", {
			scrollTrigger: {
				trigger: ".aside-content-sticky",
				start: "-100px top",
				end: "bottom top",
				ease: "power2",
				//markers: true,
				//toggleClass: "red",
				pin: ".sticky-content",
			}
		});
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}